'use strict';

var React = require('react');
var reactFinalForm = require('react-final-form');
var PropTypes = require('prop-types');
var lodash = require('lodash');
var reactRedux = require('react-redux');
var classNames = require('classnames');
var text = require('@piconetworks/text');
require('immer');
var effects = require('redux-saga/effects');
var axios = require('axios');
var Marked = require('marked');
var DOMPurify = require('dompurify');
var Form = require('@piconetworks/form');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var Marked__default = /*#__PURE__*/_interopDefaultLegacy(Marked);
var DOMPurify__default = /*#__PURE__*/_interopDefaultLegacy(DOMPurify);
var Form__default = /*#__PURE__*/_interopDefaultLegacy(Form);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var selectors = {
  isFetchingMarkdown: function isFetchingMarkdown() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        text = _ref.text;

    return text === null || text === void 0 ? void 0 : text.isFetchingMarkdown;
  },
  markdownFiles: function markdownFiles() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        text = _ref2.text;

    return text === null || text === void 0 ? void 0 : text.markdownFiles;
  },
  isFetchingJson: function isFetchingJson() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        text = _ref3.text;

    return text === null || text === void 0 ? void 0 : text.isFetchingJson;
  },
  jsonFiles: function jsonFiles() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        text = _ref4.text;

    return text === null || text === void 0 ? void 0 : text.jsonFiles;
  },
  getMarkdownFile: function getMarkdownFile(state, url) {
    var markdownFiles = selectors.markdownFiles(state);
    return markdownFiles[url];
  },
  getJsonFile: function getJsonFile(state, url) {
    var jsonFiles = selectors.jsonFiles(state);
    return jsonFiles[url];
  }
};

var actionCreatorFactory = function actionCreatorFactory(type) {
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        payload = _ref.payload,
        error = _ref.error;

    return Object.assign({
      type: type
    }, payload && {
      payload: payload
    }, error && {
      error: error
    });
  };
};

var types = {
  FETCH_MARKDOWN: 'FETCH_MARKDOWN',
  FETCH_MARKDOWN_SUCCESS: 'FETCH_MARKDOWN_SUCCESS',
  FETCH_MARKDOWN_ERROR: 'FETCH_MARKDOWN_ERROR',
  FETCH_JSON: 'FETCH_JSON',
  FETCH_JSON_SUCCESS: 'FETCH_JSON_SUCCESS',
  FETCH_JSON_ERROR: 'FETCH_JSON_ERROR'
};
var creators = {
  fetchMarkdown: actionCreatorFactory(types.FETCH_MARKDOWN),
  fetchMarkdownSuccess: actionCreatorFactory(types.FETCH_MARKDOWN_SUCCESS),
  fetchMarkdownError: actionCreatorFactory(types.FETCH_MARKDOWN_ERROR),
  fetchJson: actionCreatorFactory(types.FETCH_JSON),
  fetchJsonSuccess: actionCreatorFactory(types.FETCH_JSON_SUCCESS),
  fetchJsonError: actionCreatorFactory(types.FETCH_JSON_ERROR)
};

var styles = {"reset":"RemoteMarkdown-module_reset__2MT-b","h1":"RemoteMarkdown-module_h1__ZmrwP","h2":"RemoteMarkdown-module_h2__3-TXc","h3":"RemoteMarkdown-module_h3__5JnZs","h4":"RemoteMarkdown-module_h4__2YrxT","h5":"RemoteMarkdown-module_h5__26ZXv","h6":"RemoteMarkdown-module_h6__31Msj","clearfix":"RemoteMarkdown-module_clearfix__1nX4i","lastcol":"RemoteMarkdown-module_lastcol__cQIc6","ffluid":"RemoteMarkdown-module_ffluid__2SNWY","cb":"RemoteMarkdown-module_cb__rWcPU","fcolholder":"RemoteMarkdown-module_fcolholder__3RUKv","col":"RemoteMarkdown-module_col__18nEb","col-1_1":"RemoteMarkdown-module_col-1_1__21QiY","col-1_2":"RemoteMarkdown-module_col-1_2___kVgL","col-2_4":"RemoteMarkdown-module_col-2_4__dHZpL","col-3_6":"RemoteMarkdown-module_col-3_6__2NspJ","col-1_3":"RemoteMarkdown-module_col-1_3__1_gEp","col-2_6":"RemoteMarkdown-module_col-2_6__20p0P","col-2_3":"RemoteMarkdown-module_col-2_3__2EN6o","col-4_6":"RemoteMarkdown-module_col-4_6__y07cU","col-1_4":"RemoteMarkdown-module_col-1_4__2PwA2","col-3_4":"RemoteMarkdown-module_col-3_4__2ccl2","col-1_5":"RemoteMarkdown-module_col-1_5__SDiJW","col-2_5":"RemoteMarkdown-module_col-2_5__3qtw3","col-3_5":"RemoteMarkdown-module_col-3_5__2IWnO","col-4_5":"RemoteMarkdown-module_col-4_5__8DWUz","col-1_6":"RemoteMarkdown-module_col-1_6__2LZbO","col-5_6":"RemoteMarkdown-module_col-5_6__2545Z","ir":"RemoteMarkdown-module_ir__358_W","fl":"RemoteMarkdown-module_fl__yRNn7","fr":"RemoteMarkdown-module_fr__2Txmy","cr":"RemoteMarkdown-module_cr__3WSRV","cl":"RemoteMarkdown-module_cl__17rq1","hidden":"RemoteMarkdown-module_hidden__1S5uH","invisible":"RemoteMarkdown-module_invisible__14VoL","vcenter":"RemoteMarkdown-module_vcenter__1QNuq","outer":"RemoteMarkdown-module_outer__2ZAkS","inner":"RemoteMarkdown-module_inner__yx3QY","hcenter":"RemoteMarkdown-module_hcenter__5Rb8j","tcenter":"RemoteMarkdown-module_tcenter__1hMXw","tleft":"RemoteMarkdown-module_tleft__10Dc2","tright":"RemoteMarkdown-module_tright__12N0d","tupper":"RemoteMarkdown-module_tupper__2Gvi1","tlower":"RemoteMarkdown-module_tlower__cWuNo","tnormal":"RemoteMarkdown-module_tnormal__23OLJ","ttop":"RemoteMarkdown-module_ttop__2STA_","tmiddle":"RemoteMarkdown-module_tmiddle__mJhwu","tbottom":"RemoteMarkdown-module_tbottom__1x1VW","clickable":"RemoteMarkdown-module_clickable__3in0a","btn":"RemoteMarkdown-module_btn__n8ZcO","disabled":"RemoteMarkdown-module_disabled__1s2bc","b":"RemoteMarkdown-module_b__1hPAT","em":"RemoteMarkdown-module_em__32Io7","big":"RemoteMarkdown-module_big__3_Q2Z","small":"RemoteMarkdown-module_small__2y006","del":"RemoteMarkdown-module_del__EsEwL","nav":"RemoteMarkdown-module_nav__2e2FW","hlnav":"RemoteMarkdown-module_hlnav__3Rokq","hrnav":"RemoteMarkdown-module_hrnav__2el1i","simpleList":"RemoteMarkdown-module_simpleList__Qsv7e","gridholder":"RemoteMarkdown-module_gridholder__1xsPv","grid":"RemoteMarkdown-module_grid__3EiWS","grid-1":"RemoteMarkdown-module_grid-1__oWcKW","grid-2":"RemoteMarkdown-module_grid-2__R5hZS","grid-3":"RemoteMarkdown-module_grid-3__oR3pn","grid-4":"RemoteMarkdown-module_grid-4__3S1iR","grid-5":"RemoteMarkdown-module_grid-5__SaQbc","grid-6":"RemoteMarkdown-module_grid-6__2exop","grid-7":"RemoteMarkdown-module_grid-7__2RZKu","grid-8":"RemoteMarkdown-module_grid-8__3cNxU","grid-9":"RemoteMarkdown-module_grid-9__1kNRb","grid-10":"RemoteMarkdown-module_grid-10__r-BJn","grid-11":"RemoteMarkdown-module_grid-11__23pbC","grid-12":"RemoteMarkdown-module_grid-12__3iDvA","fgridholder":"RemoteMarkdown-module_fgridholder__2ftvk","fgrid-1":"RemoteMarkdown-module_fgrid-1__1h6C6","fgrid-2":"RemoteMarkdown-module_fgrid-2__1XyAc","fgrid-3":"RemoteMarkdown-module_fgrid-3___w6pM","fgrid-4":"RemoteMarkdown-module_fgrid-4__1sP2X","fgrid-5":"RemoteMarkdown-module_fgrid-5__7Aa5K","fgrid-6":"RemoteMarkdown-module_fgrid-6__1hW26","fgrid-7":"RemoteMarkdown-module_fgrid-7__2NVJj","fgrid-8":"RemoteMarkdown-module_fgrid-8__8Wcdm","fgrid-9":"RemoteMarkdown-module_fgrid-9__19ISU","fgrid-10":"RemoteMarkdown-module_fgrid-10__2S75O","fgrid-11":"RemoteMarkdown-module_fgrid-11__Ii4dx","fgrid-12":"RemoteMarkdown-module_fgrid-12__34QBb","wrapper":"RemoteMarkdown-module_wrapper__2DnsT"};

/* eslint-disable react/no-danger */

var RemoteMarkdown = function RemoteMarkdown(_ref) {
  var url = _ref.url,
      options = _ref.options,
      onClickLink = _ref.onClickLink;
  var dispatch = reactRedux.useDispatch();
  var markdownFile = reactRedux.useSelector(function (state) {
    return selectors.getMarkdownFile(state, url);
  }, lodash.isEqual);
  var isFetching = reactRedux.useSelector(function (state) {
    return selectors.isFetchingMarkdown(state, url);
  }, lodash.isEqual);
  React.useEffect(function () {
    if (url && !markdownFile && !(markdownFile !== null && markdownFile !== void 0 && markdownFile.error) && !isFetching) {
      dispatch(creators.fetchMarkdown({
        payload: {
          url: url,
          options: options
        }
      }));
    }
  }, [dispatch, url, options, isFetching]);

  if (!markdownFile || markdownFile.error || !markdownFile.html) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles.reset,
    dangerouslySetInnerHTML: {
      __html: markdownFile.html
    },
    onClick: function onClick(event) {
      var _event$target;

      event.stopPropagation();
      event.preventDefault();
      var href = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.href;
      onClickLink(href);
    }
  });
};

RemoteMarkdown.defaultProps = {
  onClickLink: function onClickLink() {},
  options: {}
};
RemoteMarkdown.propTypes = {
  url: PropTypes__default['default'].string.isRequired,
  onClickLink: PropTypes__default['default'].func,
  options: PropTypes__default['default'].object
};

/* eslint-disable react/no-danger */

var RemoteJsonText = function RemoteJsonText(_ref) {
  var url = _ref.url,
      linkColor = _ref.linkColor,
      style = _ref.style;
  var dispatch = reactRedux.useDispatch();
  var json = reactRedux.useSelector(function (state) {
    return selectors.getJsonFile(state, url);
  }, lodash.isEqual);
  var isFetching = reactRedux.useSelector(function (state) {
    return selectors.isFetchingJson(state, url);
  }, lodash.isEqual);
  React.useEffect(function () {
    if (!isFetching && url && !json && !(json !== null && json !== void 0 && json.error)) {
      dispatch(creators.fetchJson({
        payload: {
          url: url
        }
      }));
    }
  }, [isFetching, JSON.stringify(json)]);

  if (!json || json !== null && json !== void 0 && json.error) {
    return null;
  }

  var _ref2 = json || {},
      _ref2$description = _ref2.description,
      description = _ref2$description === void 0 ? '' : _ref2$description,
      _ref2$feature_list = _ref2.feature_list,
      featureList = _ref2$feature_list === void 0 ? [] : _ref2$feature_list;

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, description && /*#__PURE__*/React__default['default'].createElement(text.P, null, description), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: style.list
  }, featureList.map(function (item, i) {
    return /*#__PURE__*/React__default['default'].createElement("li", {
      key: i
    }, /*#__PURE__*/React__default['default'].createElement("i", {
      className: classNames__default['default'](style.icon, 'icon-icon_checkmark'),
      style: {
        color: linkColor
      }
    }), item.label, item.detail && /*#__PURE__*/React__default['default'].createElement("span", null, item.detail));
  })));
};

RemoteJsonText.defaultProps = {// options: {},
};
RemoteJsonText.propTypes = {
  url: PropTypes__default['default'].string.isRequired,
  linkColor: PropTypes__default['default'].any.isRequired,
  style: PropTypes__default['default'].any.isRequired
};
React__default['default'].memo(RemoteJsonText);

var marked = function marked(markdownString, options) {
  return new Promise(function (resolve, reject) {
    return Marked__default['default'](markdownString, options, function (err, html) {
      if (err) {
        return reject(err);
      }

      return resolve(html);
    });
  });
};

function* fetchMarkdown(_ref) {
  var payload = _ref.payload;
  var url = payload === null || payload === void 0 ? void 0 : payload.url;
  var options = (payload === null || payload === void 0 ? void 0 : payload.options) || {};

  try {
    if (!url) {
      throw new Error('markdown url must be provided');
    }

    var response = yield effects.call(axios__default['default'], {
      method: 'get',
      timeout: 5000,
      url: url
    });

    if (!response || !response.data) {
      throw new Error('response object not returned from axios');
    }

    var html = yield effects.call(marked, response.data, options);
    var cleanHtml = DOMPurify__default['default'].sanitize(html);
    yield effects.put(yield effects.call(creators.fetchMarkdownSuccess, {
      payload: {
        url: url,
        html: cleanHtml
      }
    }));
  } catch (error) {
    yield effects.put(yield effects.call(creators.fetchMarkdownError, {
      payload: {
        url: typeof url === 'undefined' ? null : url
      },
      error: error.message
    }));
  }
}

function* fetchJson(_ref) {
  var payload = _ref.payload;
  var url = payload === null || payload === void 0 ? void 0 : payload.url;

  try {
    if (!url) {
      throw new Error('markdown url must be provided');
    }

    var response = yield effects.call(axios__default['default'], {
      method: 'get',
      timeout: 5000,
      url: url
    });

    if (!response || !response.data) {
      throw new Error('response object not returned from axios');
    }

    var json = response.data;
    yield effects.put(yield effects.call(creators.fetchJsonSuccess, {
      payload: {
        url: url,
        json: json
      }
    }));
  } catch (error) {
    yield effects.put(yield effects.call(creators.fetchJsonError, {
      payload: {
        url: typeof url === 'undefined' ? null : url
      },
      error: error.message
    }));
  }
}

[effects.takeEvery(types.FETCH_MARKDOWN, fetchMarkdown), effects.takeEvery(types.FETCH_JSON, fetchJson)];

var Markdown = function Markdown() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var fieldContainerProps = _ref.fieldContainerProps,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? null : _ref$description,
      required = _ref.required,
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? 'https://s3.amazonaws.com/assets.trypico.com/gadget/kitchen-sink.md' : _ref$url,
      _ref$onClickLink = _ref.onClickLink,
      onClickLink = _ref$onClickLink === void 0 ? function () {} : _ref$onClickLink,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      rest = _objectWithoutProperties(_ref, ["fieldContainerProps", "description", "required", "url", "onClickLink", "options"]);

  return /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, fieldContainerProps, /*#__PURE__*/React__default['default'].createElement("p", null, description), /*#__PURE__*/React__default['default'].createElement(RemoteMarkdown, {
    url: url,
    onClickLink: onClickLink,
    options: Object.assign({
      breaks: true
    }, options)
  }), /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
    component: Form__default['default'].Input,
    type: "hidden"
  }, required && {
    validate: function validate(value) {
      return value ? undefined : 'Required';
    }
  }, rest)));
};
// const sendExternalLink = (href) => {
//     dispatch(Internal.creators.sendMessage({
//         payload: {
//             target: 'pico_arbiter',
//             ...Arbiter.creators.sendExternalLink({
//                 payload: href,
//             }),
//         },
//     }))
// }

module.exports = Markdown;
